"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
/**
 * Grid Label
 */
class Label {
    /**
     * Constructor
     *
     * @param name
     *            name
     * @param center
     *            center point
     * @param bounds
     *            bounds
     */
    constructor(name, center, bounds) {
        this.name = name;
        this.center = center;
        this.bounds = bounds;
    }
    /**
     * Get the name
     *
     * @return name
     */
    getName() {
        return this.name;
    }
    /**
     * Set the name
     *
     * @param name
     *            name
     */
    setName(name) {
        this.name = name;
    }
    /**
     * Get the center point
     *
     * @return center point
     */
    getCenter() {
        return this.center;
    }
    /**
     * Set the center point
     *
     * @param center
     *            center point
     */
    setCenter(center) {
        this.center = center;
    }
    /**
     * Get the bounds
     *
     * @return bounds
     */
    getBounds() {
        return this.bounds;
    }
    /**
     * Set the bounds
     *
     * @param bounds
     *            bounds
     */
    setBounds(bounds) {
        this.bounds = bounds;
    }
}
exports.Label = Label;
//# sourceMappingURL=Label.js.map